import { InlineConfirm } from '@main/pc-core-components';
import { endpoints } from '@main/pc-types';
import { updateRequest } from '@main/privacy-center/src/containers/RequestHistoryPreview/slice';
import { buildUseDhMutation } from '@main/privacy-center/src/hooks';
import type { ID } from '@main/schema-utils';
import React from 'react';
import { useDispatch } from 'react-redux';

import { revokeRequestMessages } from './messages';

const useRevokeRequest = buildUseDhMutation(endpoints.revokeRequest);

/**
 * Allow the user to cancel the request
 */
export const RevokeRequest: React.FC<{
  /** The request ID */
  id: ID<'request'>;
}> = ({ id }) => {
  const dispatch = useDispatch();
  const [revokeRequest, { loading, error }] = useRevokeRequest({
    refetchQueries: ['RequestHistory', 'RequestHistoryActiveCount'],
  });

  // This component should always be rendered when logged in
  if (!revokeRequest) {
    return <> </>;
  }

  return (
    <InlineConfirm
      confirmationMessage={revokeRequestMessages.sure}
      button={revokeRequestMessages.revoke}
      onConfirm={async () => {
        const { data } = await revokeRequest({
          variables: { id },
        });
        if (data) {
          dispatch(updateRequest({ request: data.request }));
        }
      }}
      loading={loading}
      error={error?.message}
    />
  );
};

export default RevokeRequest;
